import { Login } from '@/features/auth/routes/Login';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_public/login')({
  component: Login,
});
